import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import HomePage from './pages/HomePage'
import ServicesPage from './pages/ServicesPage'
import ServiceDetailPage from './pages/ServiceDetailPage'
import PrivacyPage from './pages/PrivacyPage'
import { useLenis } from './hooks/useLenis'
import { usePageviewTracking } from './hooks/useAnalytics'

function App() {
  // Initialize smooth scrolling for the entire app
  useLenis({
    duration: 0.6, // Shorter duration for quicker stopping
    easing: (t: number) => 1 - Math.pow(1 - t, 4), // Aggressive cubic ease-out for harsher, quicker stop
    smoothWheel: true, // Enable smooth mouse wheel scrolling
    smoothTouch: false, // Disable on mobile for better performance
    wheelMultiplier: 1, // Mouse wheel sensitivity
    touchMultiplier: 2, // Touch scroll sensitivity
  });

  // Track pageviews on route changes (cookieless, anonymous analytics)
  usePageviewTracking();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </Layout>
  )
}

export default App

